import { createContext } from 'solid-js'
import type { ButtonGroupPropsType } from '~/types/Button'

// Contexto sencillo para compartir variant/color/size desde Button.Group a Button
const ButtonGroupContext = createContext<Partial<ButtonGroupPropsType> | undefined>(undefined)

export default ButtonGroupContext
